import React, { useState, ChangeEvent, FormEvent, useEffect } from 'react';
import authAPI from '../../../api/authAPI';
import { toast } from 'react-toastify';
import FlexCardSetting from '../../../_metronic/layout/components/FlexCardSetting';
import SettingsAPI from '../../../api/SettingsAPI';

function SettingsSecurity() {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState<string>('');
  const [emailHost, setEmailHost] = useState('');
  const [emailAddress, setEmailAddress] = useState('');
  const [emailPassword, setEmailPassword] = useState('');
  const [emailServerPort, setEmailServerPort] = useState(0);
  const [emailError, setEmailError] = useState<string>('');
  const [configurationData, setConfigurationData] = useState<any>({});
  const [emailConfigurationData, setEmailConfigurationData] = useState<any>({});

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setError('');
    switch (name) {
      case 'oldPassword':
        setOldPassword(value);
        break;
      case 'newPassword':
        setNewPassword(value);
        break;
      case 'confirmPassword':
        setConfirmPassword(value);
        break;
      default:
        break;
    }
  };

  const handleEmailConfigurationChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setEmailError('');
    switch (name) {
      case 'emailHost':
        setEmailHost(value);
        break;
      case 'emailAddress':
        setEmailAddress(value);
        break;
      case 'emailPassword':
        setEmailPassword(value);
        break;
      case 'emailServerPort':
        setEmailServerPort(parseInt(value));
        break;
      default:
        break;
    }
  };

  const handleClearFields = () => {
    setOldPassword('');
    setNewPassword('');
    setConfirmPassword('');
    setError('');
  };

  const handleEmailConfigurationClearFields = () => {
    setEmailAddress('');
    setEmailHost('');
    setEmailPassword('');
    setEmailServerPort(0);
    setEmailError('');
  };

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();

    if (oldPassword === '') {
      setError('Please enter your old password.');
      return;
    }

    if (newPassword === '') {
      setError('Please enter your new password.');
      return;
    }

    if (confirmPassword === '') {
      setError('Please confirm your new password.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("New password and confirm password don't match.");
      return;
    }

    let data = {
      new_password: newPassword,
      old_password: oldPassword,
    };
    authAPI.changePassword(data).then(
      (res: any) => {
        if (res?.data?.success) {
          toast.success(res?.data?.message, { theme: 'dark' });
          handleClearFields();
        } else {
          toast.error(res?.data?.message, { theme: 'dark' });
        }
      },
      (err: any) => {
        toast.error(err?.response?.data?.message, { theme: 'dark' });
      }
    );
  };

  const handleEmailConfigurationSubmit = (event: FormEvent) => {
    event.preventDefault();

    if (emailHost === '') {
      setEmailError('Please enter email host.');
      return;
    }

    if (emailAddress === '') {
      setEmailError('Please enter email address.');
      return;
    }

    if (emailPassword === '') {
      setEmailError('Please enter email password.');
      return;
    }

    if (emailServerPort <= 0) {
      setEmailError('Please enter valid email server port.');
      return;
    }

    let data = {
      email_host: emailHost,
      email_address: emailAddress,
      email_password: emailPassword,
      mail_server_port: emailServerPort,
    };

    const apiCall = emailConfigurationData?.id
      ? authAPI.updateEmailConfiguration
      : authAPI.addEmailConfiguration;

    apiCall(data).then(
      (res: any) => {
        if (res?.data?.success) {
          toast.success(res?.data?.message, { theme: 'dark' });
          handleEmailConfigurationClearFields();
          getEmailConfiguration(); // Refresh the configuration data after submit
        } else {
          toast.error(res?.data?.message, { theme: 'dark' });
        }
      },
      (err: any) => {
        toast.error(err?.response?.data?.message, { theme: 'dark' });
      }
    );
  };

  const handleChangeToggle = (param: string, status: boolean) => {
    let data = {};
    if (param === 'is_allow_email_notification') {
      data = {
        allow_email_notification: status,
      };
    } else if (param === 'is_allow_sms_notification') {
      data = {
        allow_sms_notification: status,
      };
    } else {
      data = {};
    }

    SettingsAPI.updateConfigurationAPI(data).then(
      (res: any) => {
        if (res?.data?.success) {
          toast.success(res?.data?.message, { theme: 'dark' });
          getConfigurationDetails();
        } else {
          toast.error(res?.data?.message, { theme: 'dark' });
        }
      },
      (err: any) => {
        toast.error(err?.response?.data?.message, { theme: 'dark' });
      }
    );
  };

  //  get details configuration API
  const getConfigurationDetails = () => {
    SettingsAPI.detailsConfigurationAPI().then((res: any) => {
      if (res?.data?.success) {
        setConfigurationData(res?.data?.data);
      } else {
        setConfigurationData(res?.data?.data);
      }
    });
  };

  //  get email configuration
  const getEmailConfiguration = () => {
    authAPI.getEmailConfiguration().then((res: any) => {
      if (res?.data?.success) {
        const { email_host, email_address, email_password, mail_server_port } = res?.data?.data;
        setEmailConfigurationData(res?.data?.data);
        setEmailHost(email_host || '');
        setEmailAddress(email_address || '');
        setEmailPassword(email_password || '');
        setEmailServerPort(mail_server_port || 0);
      } else {
        toast.error(res?.data?.message, { theme: 'dark' });
      }
    });
  };

  useEffect(() => {
    getConfigurationDetails();
    getEmailConfiguration();
  }, []);

  return (
    <div className='container mt-lg-10'>
      <div className='col-lg-12 row'>
        <div className='col-lg-8'>
          <p className='fs-3 mb-2'>2-Factor Authentication</p>
          <p className='fs-4 fw-bold mb-5 '>
            Set up 2-Factor authentication below for an extra layer of security on your account
          </p>
          <div className='card mb-3'>
            <FlexCardSetting
              title='Email Notification'
              description='Get security codes to your connected email address.'
              isEnabled={configurationData?.is_allow_email_notification === 1 ? true : false}
              handleChange={handleChangeToggle}
              param='is_allow_email_notification'
            />
          </div>

          <div className='card mb-3'>
            <FlexCardSetting
              title='Text message (SMS)'
              description='Get security codes sent to your connected Phone number via SMS.'
              isEnabled={configurationData?.is_allow_sms_notification === 1 ? true : false}
              handleChange={handleChangeToggle}
              param='is_allow_sms_notification'
            />
          </div>
          <div className='col-lg-12 mt-10'>
            <p className='fs-3 mb-2'>Email Configuration</p>
            <p className='fs-4 fw-bold mb-5 '>
              Set up email configuration below filling up following fields
            </p>
            <div className='card mb-3'>
              <div className='card p-10'>
                {emailError && <div className='alert alert-danger'>{emailError}</div>}
                <form onSubmit={handleEmailConfigurationSubmit}>
                  <div className='form-group col-12 mb-3'>
                    <label htmlFor='emailHost' className='fw-bold fs-4 mb-2'>
                      Email Host
                    </label>
                    <input
                      type='text'
                      className='form-control'
                      placeholder='Enter Email Host'
                      id='emailHost'
                      name='emailHost'
                      value={emailHost}
                      onChange={handleEmailConfigurationChange}
                    />
                  </div>
                  <div className='form-group col-12 mb-3'>
                    <label htmlFor='emailAddress' className='fw-bold fs-4 mb-2'>
                      Email Address
                    </label>
                    <input
                      type='email'
                      className='form-control'
                      placeholder='Enter Email Address'
                      id='emailAddress'
                      name='emailAddress'
                      value={emailAddress}
                      onChange={handleEmailConfigurationChange}
                    />
                  </div>

                  <div className='form-group col-12 mb-3'>
                    <label htmlFor='emailPassword' className='fw-bold fs-4 mb-2'>
                      Email Password
                    </label>
                    <input
                      type='text'
                      className='form-control'
                      placeholder='Enter Email Password'
                      id='emailPassword'
                      name='emailPassword'
                      value={emailPassword}
                      onChange={handleEmailConfigurationChange}
                    />
                  </div>

                  <div className='form-group col-12 mb-5'>
                    <label htmlFor='emailServerPort' className='fw-bold fs-4 mb-2'>
                      Email Server Port
                    </label>
                    <input
                      type='number'
                      className='form-control'
                      placeholder='Enter Email Server Port'
                      id='emailServerPort'
                      name='emailServerPort'
                      value={emailServerPort}
                      onChange={handleEmailConfigurationChange}
                    />
                  </div>

                  <button
                    type='submit'
                    className='btn btn-primary w-100 text-center'
                    style={{ borderRadius: 85 }}
                  >
                    {emailConfigurationData?.email_host ? 'UPDATE' : 'ADD CONFIGURATION'}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* change password */}
        <div className='col-lg-4'>
          <div className='card p-10'>
            <p className='fs-3 mb-5'>Change Password</p>
            {error && <div className='alert alert-danger'>{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className='form-group col-12 mb-3'>
                <label htmlFor='oldPassword' className='fw-bold fs-4 mb-2'>
                  Old Password
                </label>
                <input
                  type='password'
                  className='form-control'
                  placeholder='Enter Old Password'
                  id='oldPassword'
                  name='oldPassword'
                  value={oldPassword}
                  onChange={handleChange}
                />
              </div>

              <div className='form-group col-12 mb-3'>
                <label htmlFor='newPassword' className='fw-bold fs-4 mb-2'>
                  New Password
                </label>
                <input
                  type='password'
                  className='form-control'
                  placeholder='Enter New Password'
                  id='newPassword'
                  name='newPassword'
                  value={newPassword}
                  onChange={handleChange}
                />
              </div>

              <div className='form-group col-12 mb-5'>
                <label htmlFor='confirmPassword' className='fw-bold fs-4 mb-2'>
                  Confirm New Password
                </label>
                <input
                  type='password'
                  className='form-control'
                  placeholder='Enter Confirm Password'
                  id='confirmPassword'
                  name='confirmPassword'
                  value={confirmPassword}
                  onChange={handleChange}
                />
              </div>

              <button
                type='submit'
                className='btn btn-primary w-100 text-center'
                style={{ borderRadius: 85 }}
              >
                Change Password
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SettingsSecurity;
